<template>
    <b-card no-body>
        <div class="p-1 border-bottom">
            <label class="font-weight-bold mb-50">Netsis Stoğu Ekle</label>
            <b-row class="align-items-start">
                <b-col cols="12" md="9" lg="10" class="mb-1 mb-md-0">
                    <stock-search-select ref="search" v-model="selectedStock"></stock-search-select>
                    <small class="text-muted">Stok adı veya kodu ile aratın, seçip "Ekle" ile özel kontrol listesine kaydedin.</small>
                </b-col>
                <b-col cols="12" md="3" lg="2">
                    <v-executer
                        :loading="adding"
                        :disabled="!selectedStock"
                        :action="add"
                        text="Ekle"
                        full-width></v-executer>
                </b-col>
            </b-row>
        </div>

        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    :buttons="buttons"
                    search
                    pagination="server"></v-table>
    </b-card>
</template>

<script>
import { BCard, BRow, BCol } from 'bootstrap-vue'
import { SpecialControlStockApi } from '@/api/special-control-stock'
import StockSearchSelect from './components/StockSearchSelect.vue'

export default {
    components: {
        BCard,
        BRow,
        BCol,
        StockSearchSelect
    },
    data(){
        return {
            adding: false,
            selectedStock: null,
            fields: [
                { name: 'Stok Adı', key: 'StockName', sortable: false, thClass: 'w-70' },
                { name: 'Stok Kodu', key: 'StockCode', sortable: false, thClass: 'w-30' }
            ],
            buttons: [
                { text: 'Sil', key: 'delete', icon: 'TrashIcon', variant: 'danger', action: this.remove }
            ]
        }
    },
    methods: {
        provider(data){
            return SpecialControlStockApi.Table(data)
        },
        add(){
            if(!this.selectedStock) return
            this.adding = true
            SpecialControlStockApi.Create({
                StockCode: this.selectedStock.StockCode,
                StockName: this.selectedStock.StockName
            }).then(res => {
                this.$result(res)
                this.adding = false
                if(res.data.Success){
                    this.selectedStock = null
                    if(this.$refs.search) this.$refs.search.clear()
                    this.$refs.table.refresh()
                }
            }).catch(err => {
                this.adding = false
                this.$result(null, err)
            })
        },
        remove(item){
            this.$confirm('Silmek istediğinize emin misiniz?', `Bu işlem "${item.StockName || item.StockCode}" stoğunu özel kontrol listesinden kaldıracaktır.`).then(result => {
                if(result){
                    SpecialControlStockApi.Delete(item.Id).then(res => {
                        if(res.data.Success){
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err => {
                        this.$result(null, err)
                    })
                }
            })
        }
    }
}
</script>

<style>

</style>
